

































































import { Component, Vue, Prop } from 'vue-property-decorator'
import { MissionRuleConfig } from './model/missionRuleConfig'
import CouponSelect from '@/components/coupon-select/index.vue'
import CouponTable from '../couponTable/index.vue'
import CouponDto from '../coupon/model/couponDto'
@Component({
  components: {
    CouponSelect,
    CouponTable
  }
})
export default class Mission extends Vue {
  @Prop({
    type: Object,
    required: true,
    default: () => {
      return {
        memberScope: 'All',
        memberTags: [],
        cumulativeWithOtherDiscount: false,
        discounts: [],
        missionType: '',
        rewardPoint: 0,
        extraRewardPoint: 0,
        cycle: 0,
        count: 0,
        makeUpRewardPoint: 0,
        coupons: []
      }
    }
  })
  value!: MissionRuleConfig

  cityList = [
    // {
    //   value: 'task_0001',
    //   label: '订阅消息有礼'
    // },
    {
      value: 'task_0002',
      label: '完善个人资料'
    },
    {
      value: 'task_0003',
      label: '会员注册'
    },
    {
      value: 'task_0004',
      label: '每日签到'
    },
    {
      value: 'task_0005',
      label: '邀请注册'
    },
    {
      value: 'task_0006',
      label: '订单评价'
    },
    // {
    //   value: 'task_0007',
    //   label: '文章评价有礼'
    // },
    // {
    //   value: 'task_0008',
    //   label: '分享商品有礼'
    // },
    // {
    //   value: 'task_0009',
    //   label: '填写问卷有礼'
    // },
    // {
    //   value: 'task_0010',
    //   label: '分享文章有礼'
    // }
  ]
  //1 2 3 5 6 9
  // 4 7 8
  get cycleLabelDisplayName() {
    if (this.value.missionType === 'task_0004') {
      ;(this.value as any).cycle = 5
      return '连续签到天数'
    }
    return ''
  }
  get countLableDisplayName() {
    if (this.value.missionType === 'task_0007') {
      return '每日最多赠送次数'
    }
    if (
      this.value.missionType === 'task_0008' ||
      this.value.missionType === 'task_0010'
    ) {
      return '每日分享赠送次数'
    }
    return ''
  }
  get cycleVisible() {
    return this.value.missionType === 'task_0004'
  }
  get makeUpRewardPointVisible() {
    return this.value.missionType === 'task_0004'
  }
  get extraRewardPointVisible() {
    return this.value.missionType === 'task_0004'
  }
  get maxRewardPointVisible() {
    return (
      this.value.missionType === 'task_0007' ||
      this.value.missionType === 'task_0008' ||
      this.value.missionType === 'task_0010'
    )
  }
  couponSelectChange(list) {
    console.log(list)
    this.value.coupons = this.value.coupons.concat(
      list.map(x => {
        return {
          name: x.name,
          couponTypeDisplayName: x.couponTypeDisplayName,
          validDate: x.validDate,
          value: x.id
        }
      })
    )
  }
}
